<div class="screen">
    <div class="spinner-wrapper" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <div [@fade]="animationState">
        <!-- PLAYER SCREEN -->
        <div *ngIf="banner.type == 'Player' && banner.data.length > 3" class="datacolumn">
            <span>{{banner.competition == 'UEFA Champions League' ? 'CHAMPIONS LEAGUE' : banner.competition | uppercase}}</span>
            <div class="name-container"><h2 class="name">{{banner.name | removeTildes}}</h2></div>
            <div *ngFor="let d of banner.data" class="metric">
                <h2>{{d.value | number:'1.0-1'}}</h2>
                <p class="label">{{d.label}}</p>
            </div>
        </div>

        <!-- PLAYER WITH FOTO SCREEN -->
        <div *ngIf="banner.type == 'Player' && banner.data.length < 4" class="datacolumn">
            <span>{{banner.competition == 'UEFA Champions League' ? 'CHAMPIONS LEAGUE' : banner.competition | uppercase}}</span>
            <div class="name-container"><h2 class="name">{{banner.name | removeTildes}}</h2></div>
            <div class="player-img"> <player-card [player]="banner.player ?? null"></player-card> </div>
            <div *ngFor="let d of banner.data" class="metric">
                <h2>{{d.value | number:'1.0-1'}}</h2>
                <p class="label">{{d.label}}</p>
            </div>
        </div>
        
        <!-- RANKING SCREEN -->
        <div *ngIf="banner.type == 'Ranking'" class="datacolumn">
            <span>{{banner.competition == 'UEFA Champions League' ? 'CHAMPIONS LEAGUE' : banner.competition | uppercase}}</span>
            <div class="name-container"><h2 class="name">{{banner.name}}</h2></div>
            <div *ngFor="let d of banner.data" class="ranking">
                <div class="player-img"><player-card [player]="d.player ?? null"></player-card></div>
                <h2>{{ d.value > 9 ? (d.value | number: '1.0-0') : (d.value | number: '1.0-1') }}</h2>
            </div>
        </div>

        <!-- CALENDAR SCREEN-->
        <div *ngIf="banner.type == 'Calendar'" class="datacolumn">
            <h2 class="calendar-name">{{banner.name}}</h2>
            <div *ngFor="let d of banner.data" class="calendar">
                <div class="match" [style.background]="getColor(d.competition!)">
                    <div class="badges">
                        <img class="league" [src]="getFoto(d.competition!)">
                        <span>{{ d.label }}</span>
                        <mat-icon>
                            {{d.value}}
                        </mat-icon>
                    </div>
                    <img [src]="d.team?.imgUrl">
                </div>
            </div>
        </div>

        <!-- MATCH SCREEN -->
        <div *ngIf="banner.type == 'Match'" class="datacolumn">
            <span>{{banner.competition == 'UEFA Champions League' ? 'UCL' : banner.competition | uppercase}}</span>
            <h2 class="name">{{banner.name}}</h2>
            <div class="team"><img [src]="banner.data[0].team!.imgUrl"></div>
            <h2 class="result">{{ banner.data[0].value }}</h2>
            <div class="match-league"><img [src]="getFoto(banner.competition!)"></div>
            <h2 class="result">{{ banner.data[1].value }}</h2>
            <div class="team"><img [src]="banner.data[1].team!.imgUrl"></div>
        </div>
    </div>
</div>